import React from 'react';
import { useTranslation } from 'react-i18next';

import { useEvieAppContext } from '../EvieAppProvider';

import './evie-greeting.scss';

const EvieGreeting = () => {
  const { t } = useTranslation();
  const {
    personalInfo: { name },
  } = useEvieAppContext();

  return (
    <>
      <h2 className="evie-greeting_title">
        {t('evieApp.home.title')} {name}
      </h2>
      <p>{t('evieApp.home.subtitle')}</p>
    </>
  );
};

export default EvieGreeting;
